export interface Size
{
    width: number;
    height: number;
}
export interface Pos
{
    x: number;
    y: number;
}
export class PopupCalendarConfig
{
    public cellHeight: number = 24;
    public cellWidth: number = 24;
    private width: number = 7 * this.cellWidth;

    public calendarSize: Size = {
        width: this.width,
        height: 6 * this.cellHeight
    };
    public rangeItemSize: Size = {
        width: this.width,
        height: this.cellHeight
    };
    public rangeItemPos: Pos = {
        x: 0,
        y: 0
    };

    public navigationSize: Size = {
        width: this.width,
        height: this.cellHeight
    };
    public navigationPos: Pos = {
        x: 0,
        y: 0
    };

    // public leftCalendarPos: Pos = {
    //     x: 0,
    //     y: this.navigationPos.y + this.navigationSize.height + PopupCalendarConfig.spacing
    // };
    // public rightCalendarPos: Pos = {
    //     x: this.calendarSize.width + PopupCalendarConfig.spacing,
    //     y: this.leftCalendarPos.y
    // };

    // public toolsSize: Size = {
    //     width: this.width,
    //     height: this.cellHeight
    // };
}
